import React from "react";
import { Link } from "react-router-dom";
import { Building2, Store, Globe2, Truck, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import useReveal from "../hooks/useReveal";
import { images, navPaths } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const channelIcons = [Store, Building2, Truck];

export default function Allf() {
  const { t } = useLang();
  useReveal([t]);
  const al = t.allf;
  return (
    <main>
      <Seo
        title="Mercati & Distribuzione | ALLF, il ristorante italiano nel mondo"
        description="Tre canali distributivi MichelChef®: ristoranti ALLF, B2B per Hotel/Bar/Ristoranti e distributori Horeca. Cucina gourmet italiana in Italia e nel mondo."
        path="/allf"
        image={images.dish3}
      />
      <PageHeader crumb={al.crumb} eyebrow={al.eyebrow} title={al.title} subtitle={al.subtitle} image={images.dish3} homeLabel={t.common.home} />

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="reveal relative overflow-hidden rounded-3xl bg-[#17784A] text-white p-10 card-lift">
            <Globe2 size={40} className="text-[#22B573]" />
            <h2 className="font-display font-extrabold text-3xl mt-5">{al.natTitle}</h2>
            <p className="mt-4 text-white/80 leading-relaxed">{al.natText}</p>
          </div>
          <div className="reveal reveal-delay-1 relative overflow-hidden rounded-3xl card-lift">
            <img src={images.dish4} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#14110F]/70" />
            <div className="relative p-10 text-white h-full flex flex-col justify-end min-h-[240px]">
              <Globe2 size={40} className="text-[#E85A4F]" />
              <h2 className="font-display font-extrabold text-3xl mt-5">{al.intlTitle}</h2>
              <p className="mt-4 text-white/85 leading-relaxed">{al.intlText}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F3EFE7] py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="reveal text-center max-w-2xl mx-auto">
            <span className="text-[#D8382E] font-semibold text-sm uppercase tracking-wider">{al.chanEyebrow}</span>
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-3 text-[#14110F]">{al.chanTitle}</h2>
          </div>
          <div className="mt-14 grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {t.channels.map((c, i) => {
              const Icon = channelIcons[i];
              return (
                <div key={i} className={`reveal reveal-delay-${i} bg-white rounded-2xl p-8 shadow-sm border border-black/5 card-lift hover:shadow-xl`}>
                  <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#17784A]/10 text-[#17784A]"><Icon size={26} /></span>
                  <span className="inline-block mt-5 rounded-full bg-[#D8382E]/10 text-[#D8382E] px-3 py-1 text-xs font-semibold uppercase">{c.tag}</span>
                  <h3 className="font-display font-bold text-xl mt-3 text-[#14110F]">{c.title}</h3>
                  <p className="mt-2 text-[#3B342E]/75 leading-relaxed">{c.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-24 pt-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="reveal rounded-[32px] bg-[#14110F] text-white p-10 lg:p-16 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl">{al.ctaTitle}</h2>
            <p className="mt-4 text-white/70 text-lg">{al.ctaText}</p>
          </div>
          <Link to={navPaths.contact} className="btn-press inline-flex items-center gap-2 rounded-full bg-[#22B573] text-[#083a24] px-7 py-3.5 font-semibold hover:bg-[#1ba065] shrink-0">
            {al.ctaBtn} <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </main>
  );
}
